import { useParams, Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import styles from './../pages/product.module.css';
import isLoggedIn from '../utils/isLoggedIn';
import axios from 'axios';
import CompanyCard from '../components/company_card';
import Navbar from '../components/navbar';

const Company = () => {
  const { id } = useParams();
  const url = `${process.env.REACT_APP_API}/admin/company/${id}`;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [company, setCompany] = useState(); //Product details state
  const [user, setUser] = useState(); //Client details state
  const [isloading, setLoading] = useState(true); //Loading isloading toggle
  const token = sessionStorage.getItem('token');

  // Query to get product data
  useEffect(() => {
    //check if user is logged in
    isLoggedIn(navigate, dispatch, `/company/${id}`);

    let active = true;

    (async () => {
      const response = await axios(url, {
        headers: { authorization: `Bearer ${token}` },
      });
      if (active) {
        setCompany(response.data);
        setLoading(false);
      }
    })();
    return () => {
      active = false;
      setCompany(null);
    };
  }, [id]);

  // -----------------------------------------------------------------------------

  return isloading ? (
    // Waiting data loading after async request...
    <>
      <Helmet>
        <title>Badgers SAS: Company profile</title>
        <meta name='page' content='detailed company profile' />
      </Helmet>
      <div className='loading'>
        <img src='/img/loading.gif' alt='Loading' className='loading-img' />
      </div>
    </>
  ) : (
    <>
      <Helmet>
        <title>Badgers SAS: Company profile</title>
        <meta name='page' content='detailed company profile' />
      </Helmet>
      <Navbar displayMob={true} />
      <div className={`${styles.background} container`}>
        {/* ------------Navlinks----------- */}
        <div className=''>
          <Link className='page-links' to='/'>
            <FontAwesomeIcon icon='home' />{' '}
          </Link>
          <span className='link-span'>
            <FontAwesomeIcon icon='angle-right' />
          </span>
          <Link className='page-links' to='/companies'>
            COMPANIES{' '}
          </Link>
          <span className='link-span'>
            <FontAwesomeIcon icon='angle-right' />
          </span>
          <span className='link-span'>{`${company.raisonSociale?.toUpperCase()}`}</span>
        </div>
        {/* ----------------------- */}
        <div className='col-12 d-flex justify-content-center my-4'>
          <h4 className='h4'>
            Company Profile <FontAwesomeIcon icon='building' />
          </h4>
        </div>
        <div className={`${styles.card} row g-4 my-3 pb-3`}>
          <CompanyCard company={company} />
        </div>
      </div>
    </>
  );
};

export default Company;
